const PlayBehavior = require('../behaviors/BgAnimationBehavior');
const DefaultResizeBehavior = require('../behaviors/DefaultResizeBehavior');
const OrientationResizeBehavior = require('../behaviors/OrientationResizeBehavior');

module.exports = (target, name, numLayers, el, ratio, scales) => {
    if (!name) return target;

    target._playerBehavior = PlayBehavior(name, el, numLayers);

    target._renderBehavior = null;
    target._resizeBehavior =
        (ratio && typeof ratio.push === 'function') || scales
            ? OrientationResizeBehavior(...[el].concat(ratio).concat(scales))
            : DefaultResizeBehavior(el, ratio);

    return target;
};
